import AgreementSetupPage from './AgreementSetup.page';

export default AgreementSetupPage;
